import React, { useEffect, useState } from "react";
import TabelData from "./TableData";
import PropertyDisplay from "./PropertyDisplay";
import "./PropertyList.css";
import HomeService from "../../Services/HomeService";
import { useLocation } from "react-router-dom";
const PropertyTable = ({ data, handleClick }) => {
  console.log("UYTT08", data);

  const location = useLocation();
  const { filteredProperty } = location.state || [];

  const [properties, setProperties] = useState([]);
  const [userId, setUserId] = useState("");
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (data) {
      setProperties(data);
    }
  }, [data]);

  const fetchLoginProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      console.log("This is login profile req res", response);
      setUserId(response.data?._id);
      setProfile(response?.data);
      console.log("this is userid", userId);
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  // Fetch all properties
  const fetchAllProperty = async () => {
    try {
      if (filteredProperty) {
        setProperties(filteredProperty);
      } else {
        const response = await HomeService.getProperties({ userId });
        setProperties(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
  }, []);

  // useEffect(() => {
  //   if (userId || filteredProperty) {
  //     fetchAllProperty();
  //   }
  // }, [userId, filteredProperty]);

  return (
    <>
      {properties?.map((ele, i) => {
        return (
          <PropertyDisplay
            e={ele}
            key={i}
            profile={profile}
            handleClick={handleClick}
          />
        );
      })}
    </>
  );
};

export default PropertyTable;
